import React, { useCallback } from 'react';
import { findAgentAPI } from '../../services/agentsService';

const useAgents = () => {
  const findAgents = useCallback(async (id: number) => {
    try {
      const response = await findAgentAPI(id);
      const roleData = response.data;
      return roleData;
    } catch (error) {
      console.error('Failed to fetch tranding token:', error);
      throw error;
    }
  }, []);

  return {
    findAgents,
  };
};

export default useAgents;
